import React from "react";
import {useParams} from 'react-router-dom';
import CustomerFilterCustomerList from "../../components/customer/CustomerFilterCustomerList";

const CustomerFilterCustomersPage = () => {
    const {customerFilterId} = useParams();

    return <CustomerFilterCustomerList customerFilterId={customerFilterId}/>
}

export default CustomerFilterCustomersPage;